import { DestroyRef, inject, Injectable } from '@angular/core';
import { QuoteToolLiteStore, SharedDataStore } from '../store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { valueIsNullOrUndefined } from '@lx/shared/utils';
import { Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({ providedIn: 'root' })
export class StoreOrchestratorService {
  private readonly quoteToolLiteStore = inject(QuoteToolLiteStore);
  private readonly sharedDataStore = inject(SharedDataStore);
  private readonly destroyRef = inject(DestroyRef);

  /**
   * Initializes the orchestration between the stores.
   */
  initOrchestration() {
    // Maintain the list of course languages depending on the active flow
    // Filter out undefined values to avoid loading wrong languages before store is initialized
    this.quoteToolLiteStore.activeFlow$
      .pipe(
        filter((activeFlow): activeFlow is Flow => !valueIsNullOrUndefined(activeFlow)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((activeFlow) => {
        this.sharedDataStore.updateCourseLanguages(activeFlow);
      });
  }
}
